import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LoginPage from '../pages/LoginPage';
import ProtectedRoute from './ProtectedRoute';
import Dashboard from '../pages/Dashboard';
import CompaniesPage from '../pages/CompaniesPage';
import InvoicePage from '../pages/InvoicePage';
import PaymentsPage from '../pages/PaymentsPage';
import DocumentsPage from '../pages/DocumentsPage';
import DetailsPage from '../components/companies/Details';
import DynamicsPage from '../pages/DynamicsPage';
import TicketsPage from '../pages/TicketsPage';
import TicketDetailsPage from '../pages/TicketDetailsPage';
import CompanyTicketsView from '../pages/CompanyTicketsPage';
import CouponsPage from '../pages/CouponsPage';
import TasksPage from '../pages/TasksPage';


const AppRoutes = () => {
    return (
        <Router>
            <Routes>
        {/* <div style={{ 
                transform: 'scale(0.7)', 
                transformOrigin: 'top left', 
                width: '140%',
                marginRight: 'auto' 
                }}> */}
                <Route path="/" element={<LoginPage />} />
                <Route
                    path="/dashboard"
                    element={
                        <ProtectedRoute>
                            <Dashboard />
                        </ProtectedRoute>
                    }
                />
                <Route path="/companies" element={
                    <ProtectedRoute>
                        <CompaniesPage />
                    </ProtectedRoute>
                    } />
                <Route path="/dynamics" element={
                    <ProtectedRoute>
                        <DynamicsPage/>
                    </ProtectedRoute>} />
                <Route path="/tickets" element={
                    <ProtectedRoute>
                        <TicketsPage />
                    </ProtectedRoute>} />
                <Route path="/tickets/:id" element={
                    <ProtectedRoute>
                        <TicketDetailsPage />
                    </ProtectedRoute>} />
                <Route path="/coupons" element={
                    <ProtectedRoute>
                        <CouponsPage />
                    </ProtectedRoute>} />
                <Route path="/tasks" element={
                    <ProtectedRoute>
                        <TasksPage />
                    </ProtectedRoute>} />

                <Route path="/companies/:id/details" element={<ProtectedRoute><DetailsPage /></ProtectedRoute>} />
                <Route path="/companies/:id/invoices" element={<ProtectedRoute><InvoicePage /></ProtectedRoute>} />
                <Route path="/companies/:id/payments" element={<ProtectedRoute><PaymentsPage /></ProtectedRoute>} />
                <Route path="/companies/:id/documents" element={<ProtectedRoute><DocumentsPage /></ProtectedRoute>} />
                <Route path="/companies/:id/tickets" element={<ProtectedRoute><CompanyTicketsView /></ProtectedRoute>} />
            </Routes>
            {/* </div> */}
        </Router>
    );
};

export default AppRoutes;
